import { Field } from 'formik';
import React from 'react';
const TextArea = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  maxLength,
  minLength,
  errormsg,
  fieldFlag,
  disabled,
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      {disabled ? (
        <div className="textarea">{value ? value : '--'}</div>
      ) : (
        <Field
          className={`formik-input custom-textarea${disabled ? ' disabled' : ''}`}
          {...(isRequired ? { required: true } : {})}
          as="textarea"
          type="text"
          name={name}
          fullwidth
          disabled={disabled}
          autoComplete="given-name"
          id={'textarea-' + name}
          variant="outlined"
          value={value ?? defaultValue ?? ''}
          onChange={(e) => handleChange(e, fieldFlag)}
          {...(maxLength && maxLength > 0 ? { maxLength: maxLength } : {})}
          {...(minLength && minLength > 0 ? { minLength: minLength } : {})}
          {...(placeholder ? { placeholder: placeholder } : {})}
        />
      )}
      {errormsg && <div className="error-message">{errormsg}</div>}
    </>
  );
};

export default TextArea;
